export const AdditionalNeedsTypeEnum = Object.freeze({
    HEARING: 'HEARING',
    VISUAL: 'VISUAL',
    COGNITIVE: 'COGNITIVE',
    LITERACY_NUMERACY: 'LITERACY_NUMERACY',
    NEURODIVERSE: 'NEURODIVERSE',
    PHYSICAL_LONG_TERM_ILLNESS: 'PHYSICAL_LONG_TERM_ILLNESS',
    TERMINAL_ILLNESS: 'TERMINAL_ILLNESS',
    MENTAL_HEALTH: 'MENTAL_HEALTH',
    BLOCKED_ACCESS: 'BLOCKED_ACCESS',
    EMOTIONAL_LIFE_CHANGE: 'EMOTIONAL_LIFE_CHANGE',
    FINANCIAL_HARDSHIP: 'FINANCIAL_HARDSHIP',
    TEMPORARY_ILL_HEALTH: 'TEMPORARY_ILL_HEALTH',
    UNEMPLOYMENT_REDUNDANCY: 'UNEMPLOYMENT_REDUNDANCY',
    TECHNOLOGY_ISSUES: 'TECHNOLOGY_ISSUES'
});
